import { render } from "./JobPreview.vue?vue&type=template&id=5a4a0f60&scoped=true"
import script from "./JobPreview.vue?vue&type=script&lang=js"
export * from "./JobPreview.vue?vue&type=script&lang=js"

import "./JobPreview.vue?vue&type=style&index=0&id=5a4a0f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4a0f60"]])

export default __exports__